import React, { useState } from 'react';
import '../App.css';
import ReleasesAdmin from '../components/admin/ReleasesAdmin';
import ArtistsAdmin from '../components/admin/ArtistsAdmin';
import MerchAdmin from '../components/admin/MerchAdmin';
import { useNavigate } from 'react-router-dom';

function AdminConsole() {
  const [activeTab, setActiveTab] = useState('releases');
  const navigate = useNavigate();

  // Simple guard: if no token, redirect to login
  const token = (() => {
    try {
      return localStorage.getItem('token');
    } catch {
      return null;
    }
  })();

  if (!token) {
    navigate('/login', { replace: true });
    return null;
  }

  return (
    <div className="App">
      <div className="admin-container">
        <a href="/" className="back-link" onClick={(e) => { e.preventDefault(); window.location.href = '/'; }}>← Back to Site</a>
        
        <div className="admin-header">
          <h1>ADMIN CONSOLE</h1>
          <p>Manage Releases, Artists & Merch</p>
        </div>

        <div className="admin-nav">
          <button 
            className={activeTab === 'releases' ? 'active' : ''}
            onClick={() => setActiveTab('releases')}
          >
            RELEASES
          </button>
          <button 
            className={activeTab === 'artists' ? 'active' : ''}
            onClick={() => setActiveTab('artists')}
          >
            ARTISTS
          </button>
          <button 
            className={activeTab === 'merch' ? 'active' : ''}
            onClick={() => setActiveTab('merch')}
          >
            MERCH
          </button>
        </div>

        {activeTab === 'releases' && <ReleasesAdmin />}
        {activeTab === 'artists' && <ArtistsAdmin />}
        {activeTab === 'merch' && <MerchAdmin />}
      </div>
    </div>
  );
}

export default AdminConsole;

